export enum RequestStatus {
    None,
    Loading,
    Completed,
    Failed
}
